import { useEffect, useState } from "react";
import { ListingContent } from "../components/ListingDetails/LisitngContent";
import { ListingHeader } from "../components/ListingDetails/ListingHeader";
import { Navbar } from "../components/Navbar";
import { getListingById } from "../api/listingApi";
import { useNavigate, useParams } from "react-router-dom";
import { ListingNotFound } from "../components/ListingDetails/ListingNotFound";

const ListingDetails = () => {
  const [listing, setLisitng] = useState(null);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const { id } = useParams();

  useEffect(() => {
    const fetchLisitng = async () => {
      try {
        setLoading(true);

        if (!id) {
          navigate("/browse");
          return;
        }

        const data = await getListingById(id);

        if (!data) {
          navigate("/browse");
          return;
        }
        console.log("lsiting details data", data);

        const mappedListing = {
          id: data._id,
          title: data.title,
          description: data.description,
          imageUrl: data.image,
          location: data.location || "No location",
          date: new Date(data.createdAt).toLocaleDateString(),
          category: data.category?.name,
          barterFor: data.barterFor?.map((item) => item.name),
          userName: `${data.seller?.firstName || "Unknown"} ${
            data.seller?.lastName || ""
          }`,
          userAvatar: data.seller?.image,
          userRating: data.seller?.rating || 0,
          sellerId: data.seller?._id,   
          isFoundingMember: data.seller?.isFoundingMember,
        };

        setLisitng(mappedListing);
      } catch (error) {
        console.error(error);
        navigate("/browse");
      } finally {
        setLoading(false);
      }
    };

    fetchLisitng();
  }, [id, navigate]);

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <p className="text-xl font-semibold">Loading...</p>
      </div>
    );
  }

  // Only show ListingNotFound after loading is complete and listing is still null
  if (!loading && !listing) {
    return <ListingNotFound />;
  }

  return (
    <div className="min-h-screen flex flex-col">
      <Navbar />
      <main className="flex-1 pt-24 pb-16">
        <div className="container px-4 mx-auto">
          <ListingHeader />
          <ListingContent listing={listing} />
        </div>
      </main>

      {/* Footer */}
      <footer className="bg-igbanwo-mint/5 p-8 border-t border-border/60">
        <div className="container px-4 mx-auto text-center text-sm text-muted-foreground">
          &copy; {new Date().getFullYear()} Thoreau Consulting (PTY) Ltd. All rights reserved.
        </div>
      </footer>
    </div>
  );
};

export default ListingDetails;
